"use strict";

var _classCallCheck = require("/Users/georgiavramov/limechain/new-abridged/abridged/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/georgiavramov/limechain/new-abridged/abridged/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/Users/georgiavramov/limechain/new-abridged/abridged/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/Users/georgiavramov/limechain/new-abridged/abridged/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var operators_1 = require("rxjs/operators");

var UniqueSubject_1 = require("./UniqueSubject");

var StateSubject = /*#__PURE__*/function (_UniqueSubject_1$Uniq) {
  _inherits(StateSubject, _UniqueSubject_1$Uniq);

  var _super = _createSuper(StateSubject);

  function StateSubject() {
    var _this;

    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, StateSubject);

    _this = _super.call(this, value, options);
    _this.subSubjects = new Map();
    _this.defaultValue = value;
    return _this;
  }

  _createClass(StateSubject, [{
    key: "reset",
    value: function reset() {
      this.next(this.defaultValue);
    }
  }, {
    key: "getSubSubject",
    value: function getSubSubject(key) {
      if (!this.subSubjects.has(key)) {
        var subject = new UniqueSubject_1.UniqueSubject();
        this.pipe(operators_1.map(function (state) {
          var result = null;

          if (state && typeof state === 'object' && state[key] !== null) {
            result = state[key];
          }

          return result;
        })).subscribe(subject);
        this.subSubjects.set(key, subject);
      }

      return this.subSubjects.get(key);
    }
  }]);

  return StateSubject;
}(UniqueSubject_1.UniqueSubject);

exports.StateSubject = StateSubject;